angular.module('nv.routes.auth', ['ui.router', 'nv.routes.config']);
